import { ClockIcon, DocumentCheckIcon, ExclamationCircleIcon, NoSymbolIcon, TrophyIcon } from '@heroicons/react/24/solid';
import { FirmActiveWork } from '../../../types/firm';
import StatisticCard from '../../../components/statistic-card/StatisticCard';
import plural from '../../../utilities/plural';

type StatisticsProps = {
    activeWork: FirmActiveWork;
};

function Statistics({ activeWork }: StatisticsProps): JSX.Element {
    const { activeCount, avgProgressPercent, onSchedulePercent, overdueCount, avgOverdueDays } = activeWork;

    return (
        <section className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
            <StatisticCard
                title="Open"
                description={plural(activeCount, 'workpaper', 'workpapers')}
                value={activeCount}
                icon={<DocumentCheckIcon />}
                colour="indigo"
            />
            <StatisticCard title="Average Progress" description="%" value={avgProgressPercent} icon={<TrophyIcon />} colour="blue" />
            <StatisticCard title="On-Schedule" description="%" value={onSchedulePercent} icon={<ClockIcon />} colour="pink" />
            <StatisticCard
                title="Overdue"
                description={plural(overdueCount, 'workpaper', 'workpapers')}
                value={overdueCount}
                icon={<ExclamationCircleIcon />}
                colour="orange"
            />
            <StatisticCard
                title="Avg. Overdue Time"
                description={plural(avgOverdueDays, 'day', 'days')}
                value={avgOverdueDays}
                icon={<NoSymbolIcon />}
                colour="red"
            />
        </section>
    );
}

export default Statistics;
